<div class="row align-items-center">
  <div class="col-sm-1">
    {{'doctrine.solution.action_form.title' | translate}}
  </div>
  <div class="col-sm-7">
    <input class="form-control" type="text" [(ngModel)]="solution.solutionSteps[Index].actionForm.title"
           (ngModelChange)="updateSolution()">
  </div>
</div>
<div class="row align-items-center">
  <div class="col-sm-8">
    <div>
      <br>
      <div><strong>{{'admin.solution.template.action_form.selection_fields' | translate}}</strong></div>
      <hr>
      <div class="row">
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.reference"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.reference"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.reference"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.reference' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.street"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.street"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.street"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.street' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.houseNumber"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.houseNumber"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.houseNumber"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.houseNumber' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.postalCode"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.postalCode"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.postalCode"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.postalCode' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.city"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.city"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.city"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.city' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.country"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.country"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.country"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.country' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.phoneNumber"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.phoneNumber"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.phoneNumber"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.phoneNumber' | translate}}</label>
            </div>
          </div>
        </div><div class="col-sm-4 m-b-10 d-flex align-items-center">
          <div class="border-checkbox-section">
            <div class="border-checkbox-group border-checkbox-group-primary">
              <input type="checkbox" class="border-checkbox"
                     id="solution.solutionSteps[{{Index}}].actionForm.email"
                     [(ngModel)]="solution.solutionSteps[Index].actionForm.email"
                     (ngModelChange)="updateSolution()">
              <label
                for="solution.solutionSteps[{{Index}}].actionForm.email"
                class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.email' | translate}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-1">
    <div class="d-flex align-items-center m-b-10">
      <div class="border-checkbox-section">
        <div class="border-checkbox-group border-checkbox-group-primary">
          <input type="checkbox" class="border-checkbox"
                 id="solution.solutionSteps[{{Index}}].actionForm.extraField"
                 [(ngModel)]="solution.solutionSteps[Index].actionForm.extraField"
                 (ngModelChange)="updateSolution()">
          <label
            for="solution.solutionSteps[{{Index}}].actionForm.extraField"
            class="m-l-5 m-b-0 border-checkbox-label">{{'doctrine.solution.action_form.checkbox' | translate}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-7">
    <input class="form-control m-l-5" *ngIf="solution.solutionSteps[Index].actionForm.extraField" type="text"
           placeholder="{{'doctrine.solution.action_form.checkbox_description' | translate}}"
           [(ngModel)]="solution.solutionSteps[Index].actionForm.extraFieldName"
           (ngModelChange)="updateSolution()">
  </div>
</div>
